const accountControlStyles = `
  button.account__close,
  button.account__close:hover {
    background: none;
  }

  shopify-login-form-loader,
  shopify-login-form {
    font-weight: var(--shopify-account-font-body-weight);
  }

  @media screen and (min-width: 700px) and (prefers-reduced-motion: no-preference) {
    dialog.dialog {
      --dialog-drawer-opening-animation: jomo-account-slide-in;
      --dialog-drawer-closing-animation: jomo-account-slide-out;
      --dialog-drawer-easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    dialog.dialog[open] {
      animation-duration: 0.3s;
    }

    dialog.dialog::backdrop {
      transition-duration: 0.3s;
      transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    /* Shopify closes the native dialog after 180ms; finish the exit before then. */
    dialog.dialog.closing {
      animation-duration: 0.18s;
    }

    dialog.dialog.closing::backdrop {
      transition-duration: 0.18s;
    }
  }

  @keyframes jomo-account-slide-in {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
  }

  @keyframes jomo-account-slide-out {
    from { transform: translateX(0); }
    to { transform: translateX(100%); }
  }
`;

const loginControlStyles = `
  .login-form__email-input {
    font-weight: var(--shopify-login-form-font-body-weight);
  }
`;

const observedAccountRoots = new WeakSet();

function installStyles(root, marker, styles) {
  if (!root || root.querySelector(`style[${marker}]`)) return;

  const style = document.createElement('style');
  style.setAttribute(marker, '');
  style.textContent = styles;
  root.append(style);
}

function styleAccountControls(account) {
  const root = account.shadowRoot;
  if (!root) return;

  const refresh = () => {
    installStyles(root, 'data-jomo-account-controls', accountControlStyles);
    root.querySelectorAll('shopify-login-form').forEach((form) => {
      installStyles(form.shadowRoot, 'data-jomo-login-controls', loginControlStyles);
    });
  };

  refresh();

  if (!observedAccountRoots.has(root)) {
    new MutationObserver(refresh).observe(root, { childList: true, subtree: true });
    observedAccountRoots.add(root);
  }
}

function styleAccountsWithin(root) {
  if (root.matches?.('shopify-account')) styleAccountControls(root);
  root.querySelectorAll('shopify-account').forEach(styleAccountControls);
}

document.addEventListener('open', (event) => {
  if (event.target.localName === 'shopify-account') styleAccountControls(event.target);
}, true);

document.addEventListener('shopify:section:load', (event) => {
  styleAccountsWithin(event.target);
});

customElements.whenDefined('shopify-account').then(() => styleAccountsWithin(document));
customElements.whenDefined('shopify-login-form').then(() => styleAccountsWithin(document));
